import { Icon } from '@iconify/react';
import peopleFill from '@iconify/icons-eva/people-fill';
import personFill from '@iconify/icons-eva/person-fill';
import globe2Fill from '@iconify/icons-eva/globe-2-fill';
import awardFill from '@iconify/icons-eva/award-fill';
import creditCardFill from '@iconify/icons-eva/credit-card-fill';
import briefcaseFill from '@iconify/icons-eva/briefcase-fill';
import layersFill from '@iconify/icons-eva/layers-fill';
import trendingUpFill from '@iconify/icons-eva/trending-up-fill';
import gridFill from '@iconify/icons-eva/grid-fill';
import emailFill from '@iconify/icons-eva/email-fill';
import EvaPieChart2Fill from '@iconify/icons-eva/pie-chart-2-fill';
import fileTextFill from '@iconify/icons-eva/file-text-fill';
import teamFill from '@iconify/icons-eva/people-outline';
import checkmarkSquareFill from '@iconify/icons-eva/checkmark-square-fill';
import activityFill from '@iconify/icons-eva/activity-fill';
import bookOpenFill from '@iconify/icons-eva/book-open-fill';
import videoFill from '@iconify/icons-eva/video-fill';
import shareFill from '@iconify/icons-eva/share-fill';
import paperPlaneFill from '@iconify/icons-eva/paper-plane-fill';
import inboxFill from '@iconify/icons-eva/inbox-fill';
import edit2Fill from '@iconify/icons-eva/edit-2-fill';
import { getOutreachRoleFlags } from '../../utils/Authorization/outreachRole';

// ----------------------------------------------------------------------

const getIcon = (name) => <Icon icon={name} width={22} height={22} />;

const getSideBarConfig = (userInfo) => {
	const outreach = getOutreachRoleFlags(userInfo);
	return [
		{
			title: 'Companies',
			path: 'dashboard',
			icon: getIcon(EvaPieChart2Fill)
		},
		{
			title: 'DND Companies',
			path: 'dnd-companies',
			icon: getIcon('mdi:cancel')
		},
		{
			title: 'Tasks',
			path: 'tasks',
			icon: getIcon(checkmarkSquareFill)
		},
		{
			title: 'Invoicing',
			path: 'invoicing',
			icon: getIcon(creditCardFill)
		},
		{
			title: 'Partners',
			path: 'partners',
			icon: getIcon('mdi:handshake')
		},
		...(userInfo?.active_role !== 'USER'
			? [
				{
					title: 'Import History',
					path: 'excel-import',
					icon: getIcon(fileTextFill)
				}
			]
			: []),
		{
			title: 'Newsletter',
			path: 'bulk-outreach',
			icon: getIcon(emailFill)
		},
		...(outreach.effective_role === 'SUPER_ADMIN'
			? [
				{ title: 'Outreach Campaigns', path: 'outreach/campaigns',  icon: getIcon(paperPlaneFill) },
				{ title: 'Live Monitor',       path: 'outreach/monitor',    icon: getIcon(activityFill) },
				{ title: 'Outreach Accounts',  path: 'outreach/accounts',   icon: getIcon(inboxFill) },
				{ title: 'Message Templates',  path: 'outreach/templates',  icon: getIcon(fileTextFill) },
				{ title: 'Outreach Segments',  path: 'outreach/segments',   icon: getIcon(layersFill) },
			]
			: []),
		...(outreach.effective_role === 'USER'
			? [
				{ title: 'My Outreach',  path: 'my-outreach',        icon: getIcon(paperPlaneFill) },
				{ title: 'Daily Review', path: 'my-outreach/review', icon: getIcon(fileTextFill) },
			]
			: []),
		// Signature is per-user, so everyone (admins + PMs) needs access.
		{ title: 'Signature', path: 'signature', icon: getIcon(edit2Fill) },
		{
			title: 'Outlook Email',
			path: 'outlook-email',
			icon: getIcon(emailFill)
		},
		{
			title: 'Outlook Calendar',
			path: 'outlook-calendar',
			icon: getIcon('mdi:calendar')
		},
		...(userInfo?.active_role === 'SUPER_ADMIN'
			? [
				{
					title: 'Teams',
					path: 'teams',
					icon: getIcon(peopleFill)
				}]
			: []),
		{
			title: 'Performance Scorecard',
			path: 'performance',
			icon: getIcon(trendingUpFill)
		},
		{
			title: 'Templates',
			path: 'templates',
			icon: getIcon(fileTextFill)
		},
		{
			title: 'Outreach',
			path: 'prompt-library',
			icon: getIcon(activityFill)
		},
		{
			title: 'Learning',
			path: 'learning',
			icon: getIcon(videoFill)
		},
		{
			title: 'Shared Videos',
			path: 'shared-videos',
			icon: getIcon(shareFill)
		},
		...(userInfo?.active_role === 'SUPER_ADMIN'
			? [
				{
					title: 'Command Center',
					path: 'command-center',
					icon: getIcon(EvaPieChart2Fill)
				},
				{
					title: 'Master Data',
					path: 'master-data',
					icon: getIcon(layersFill)
				},
				{
					title: 'User',
					path: 'users',
					icon: getIcon(personFill)
				},
				{
					title: 'Location',
					path: 'location',
					icon: getIcon(globe2Fill)
				},
				{
					title: 'Practice',
					path: 'practice',
					icon: getIcon(awardFill)
				},
				{
					title: 'Currency',
					path: 'currency',
					icon: getIcon(creditCardFill)
				},
				{
					title: 'Designation',
					path: 'cmd',
					icon: getIcon(briefcaseFill)
				},
				{
					title: 'Company Type',
					path: 'company-type',
					icon: getIcon(layersFill)
				},
				{
					title: 'Confidence Level',
					path: 'confidence-level',
					icon: getIcon(trendingUpFill)
				},
				{
					title: 'Industry',
					path: 'industry',
					icon: getIcon(gridFill)
				},
				{
					title: 'Sender Details',
					path: 'sender-details',
					icon: getIcon(personFill)
				},
				{
					title: 'Syndication Investors',
					path: 'syndication/investors',
					icon: getIcon(briefcaseFill)
				},
				{
					title: 'Syndication Deals',
					path: 'syndication/deals',
					icon: getIcon(layersFill)
				},
				{
					title: 'Syndication Founders',
					path: 'syndication/founders',
					icon: getIcon(personFill)
				},
				{
					title: 'Syndication Analytics',
					path: 'syndication/analytics',
					icon: getIcon(trendingUpFill)
				},
				{
					title: 'Syndication Settings',
					path: 'syndication/settings',
					icon: getIcon(gridFill)
				}
			]
			: []),
		// {
		// 	title: 'Cleanup Companies',
		// 	path: 'companies',
		// 	icon: getIcon(layersFill)
		// }
	];
};

export default getSideBarConfig;
